import React from "react";
import { Link } from "react-router-dom";

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  CardImg
} from "reactstrap";

import img1 from "../../assets/images/fix-class.png";
import img2 from "../../assets/images/comp-class.png";
import img3 from "../../assets/images/attendance.png";
import img4 from "../../assets/images/no-show.png";
import img5 from "../../assets/images/cancellation.png";
import img6 from "../../assets/images/close-class.png";
import img7 from "../../assets/images/pause-profile.png";
import img8 from "../../assets/images/summary.png";
import img9 from "../../assets/images/trouble-maker.png";
import img10 from "../../assets/images/payment-status.png";


const Report = () => {
  const user = JSON.parse(localStorage.getItem("authUser"));
  //meta title
  document.title = "Reports | KDC - Admin";

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Reports"
          breadcrumbItems={[
            { title: "Reports" }
          ]}
        />

        <Row>
          <Col md={3}>
            <Link to="/fixclass-report" className="card-link">
              <Card>
                <CardImg top className="img-fluid" src={img1} alt="kdc" />
                <CardBody>
                  <CardTitle className="h4 text-center" style={{ fontSize: "18px" }}>Fixed Class Report</CardTitle>
                </CardBody>
              </Card>
            </Link>
          </Col>
          <Col md={3}>
            <Link to="/compclass-report" className="card-link">
              <Card>
                <CardImg top className="img-fluid" src={img2} alt="kdc" />
                <CardBody>
                  <CardTitle className="h4 text-center" style={{ fontSize: "18px" }}>Compensatory Class Report</CardTitle>
                </CardBody>
              </Card>
            </Link>
          </Col>
          <Col md={3}>
            <Link to="/attendance-report" className="card-link">
              <Card>
                <CardImg top className="img-fluid" src={img3} alt="kdc" />
                <CardBody>
                  <CardTitle className="h4 text-center" style={{ fontSize: "18px" }}>Attendance Report</CardTitle>
                </CardBody>
              </Card>
            </Link>
          </Col>
          <Col md={3}>
            <Link to="/noshow-report" className="card-link">
              <Card>
                <CardImg top className="img-fluid" src={img4} alt="kdc" />
                <CardBody>
                  <CardTitle className="h4 text-center" style={{ fontSize: "18px" }}>No-Show Report</CardTitle>
                </CardBody>
              </Card>
            </Link>
          </Col>
          <Col md={3}>
            <Link to="/cancellation-report" className="card-link">
              <Card>
                <CardImg top className="img-fluid" src={img5} alt="kdc" />
                <CardBody>
                  <CardTitle className="h4 text-center" style={{ fontSize: "18px" }}>Cancellation Report</CardTitle>
                </CardBody>
              </Card>
            </Link>
          </Col>
          {user?.Role !== "Student" && (
            <>
              <Col md={3}>
                <Link to="/closeclass-report" className="card-link">
                  <Card>
                    <CardImg top className="img-fluid" src={img6} alt="kdc" />
                    <CardBody>
                      <CardTitle className="h4 text-center" style={{ fontSize: "18px" }}>Close Class Report</CardTitle>
                    </CardBody>
                  </Card>
                </Link>
              </Col>
              <Col md={3}>
                <Link to="/pauseprofile-report" className="card-link">
                  <Card>
                    <CardImg top className="img-fluid" src={img7} alt="kdc" />
                    <CardBody>
                      <CardTitle className="h4 text-center" style={{ fontSize: "18px" }}>Pause Profile Report</CardTitle>
                    </CardBody>
                  </Card>
                </Link>
              </Col>
              <Col md={3}>
                <Link to="/summary-report" className="card-link">
                  <Card>
                    <CardImg top className="img-fluid" src={img8} alt="kdc" />
                    <CardBody>
                      <CardTitle className="h4 text-center" style={{ fontSize: "18px" }}>Summary Report</CardTitle>
                    </CardBody>
                  </Card>
                </Link>
              </Col>
              <Col md={3}>
                <Link to="/troublemaker-report" className="card-link">
                  <Card>
                    <CardImg top className="img-fluid" src={img9} alt="kdc" />
                    <CardBody>
                      <CardTitle className="h4 text-center" style={{ fontSize: "18px" }}>Troublemaker Report</CardTitle>
                    </CardBody>
                  </Card>
                </Link>
              </Col>
            </>
          )}
          <Col md={3}>
            <Link to="/paymentstatus-report" className="card-link">
              <Card>
                <CardImg top className="img-fluid" src={img10} alt="kdc" />
                <CardBody>
                  <CardTitle className="h4 text-center" style={{ fontSize: "18px" }}>Payment Status Report</CardTitle>
                </CardBody>
              </Card>
            </Link>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Report;
